/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-27 12:05:12
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-09 17:31:43
 * @FilePath: /unifyxp-v2-store-portal/src/components/Upload/EditModal/index.tsx
 */
import _ from 'lodash';
import React, { useEffect } from 'react';

import ImageEditor from '@toast-ui/react-image-editor';

import CropModal from './CropModal';
import {
  Button,
  Modal,
  BlurValidateInput,
  BlurValidateTextArea,
} from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import WarningPopReminder from 'src/constrains/PopReminder/Warning';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import CountWords from '@/src/components/CountWords/CountWords';
import { ImageFile } from '../ImageDisplay/imageDisplay';
import {
  //saveInstance,
  saveToSource,
} from '@/src/request/mediaLibrary';
import {
  dataURItoBlob, //convertRes2Blob
} from '@/src/tools/helper';

import css from './css.less';
import 'tui-image-editor/dist/tui-image-editor.css';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

interface IProps {
  image: ImageFile;
  visible: boolean;
  index: number;
  onOk: (image: ImageFile, index: number) => void;
  onCancel: () => void;
}

const EditModal = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const { image, visible, index, onOk, onCancel } = props;
  const {
    uuid,
    url,
    originalName,
    size,
    width,
    height,
    createdDate,
    altText,
    description,
    instanceName,
  } = image || {};

  const [
    saveLoading, // setSaveLoading
  ] = React.useState(false);
  const [copyLoading, setCopyLoading] = React.useState(false);
  const [stack, setStack] = React.useState(0);
  const [src, setSrc] = React.useState('');
  const [ratio, setRatio] = React.useState(1);
  const [showCrop, setShowCrop] = React.useState(false);
  const [valueCopy, setValueCopy] = React.useState<any>({});
  //const [_src, _setSrc] = React.useState(null);

  const [imageProps, setImageProps] = React.useState({ width, height });

  // const [_size,setS]

  const [errDisplay, setErrDisplay] = React.useState({
    instance: { hasError: false, display: false },
    alt: { hasError: false, display: false },
    des: { hasError: false, display: false },
  });
  const [value, setValue] = React.useState({
    instance: instanceName || '',
    alt: altText || '',
    des: description || '',
  });

  const ref = React.useRef<any>();

  // const ref = React.useCallback((node) => {
  //   _ref.current = node;
  //   console.log(node);
  // }, []);

  const onChange = (key, v) => {
    const _e = errDisplay[key];
    setErrDisplay({
      ...errDisplay,
      [key]: { ..._e, display: true },
    });
    setValue({
      ...value,
      [key]: v,
    });
  };

  useEffect(() => {
    setValue({
      instance: instanceName || '',
      alt: altText || '',
      des: description || '',
    });
    setValueCopy({
      instance: instanceName || '',
      alt: altText || '',
      des: description || '',
    });
  }, [visible]);

  React.useEffect(() => {
    if (stack !== 0) {
      try {
        if (ref.current) {
          const instance = ref.current.getInstance();
          const { width, height } = instance.getCanvasSize();
          setImageProps({ width, height });
        }
      } catch (e) {
        console.error(e);
      }
    } else {
      setImageProps({ width, height });
    }
  }, [stack]);

  useEffect(() => {
    if (ref.current) {
      const instance = ref.current.getInstance();
      const ele = ref.current;
      instance.loadImageFromURL(url, originalName);
      ele.getRootElement().classList.add(css.imageEditor);
      // const _ele = document.querySelector('.upper-canvas');
      // _ele.get
    }
  }, []);

  const crop = () => {
    const instance = ref.current.getInstance();
    const { width, height } = instance.getCanvasSize();
    setRatio(width / height);
    setShowCrop(true);
    setSrc(instance.toDataURL());
    setStack(stack + 1);
  };

  const rotateLeft = () => {
    const instance = ref.current.getInstance();
    instance.rotate(-90, false);
    setStack(stack + 1);
  };

  const rotateRight = () => {
    const instance = ref.current.getInstance();
    instance.rotate(90, true);
    setStack(stack + 1);
  };

  const flipVertical = () => {
    const instance = ref.current.getInstance();
    instance.flipY();
    setStack(stack + 1);
  };

  const flipHorizontal = () => {
    const instance = ref.current.getInstance();
    instance.flipX();
    setStack(stack + 1);
  };

  const addText = () => {
    const instance = ref.current.getInstance();
    instance.addText('init text', {
      styles: {
        fill: '#fff',
        fontSize: 20,
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
      },
    });
    setStack(stack + 1);
  };

  const undo = () => {
    const instance = ref.current.getInstance();
    if (stack > 0) {
      instance.undo();
      setStack(stack - 1);
    }
  };

  const redo = () => {
    const instance = ref.current.getInstance();
    if (stack > 0) {
      instance.redo();
      setStack(stack + 1);
    }
  };

  const handleCrop = (info) => {
    const instance = ref.current.getInstance();
    instance.crop(info).then(() => {
      setShowCrop(false);
      setStack(stack + 1);
    });
  };

  // const handleOnOk = async () => {
  //   try {
  //     setSaveLoading(true);
  //     const file = generateFile();

  //     const img = await saveInstance(uuid, {
  //       instanceName: value.instance,
  //       file,
  //       altText: value.alt,
  //       description: value.des,
  //     });
  //     if (onOk) onOk(img, index);
  //     if (onCancel) onCancel();
  //   } catch (e) {
  //   } finally {
  //     setSaveLoading(false);
  //   }
  // };

  const handleResetAll = async () => {
    const instance = ref.current.getInstance();
    await instance.clearObjects();
    await instance.loadImageFromURL(url, originalName);
    setStack(0);
  };

  const handleSaveToSource = async () => {
    try {
      setCopyLoading(true);
      const file = generateFile();
      // console.log('file', file);
      // const blobURL = window.URL.createObjectURL(file);
      // // 创建a标签，用于跳转至下载链接
      // const tempLink = document.createElement('a');
      // tempLink.style.display = 'none';
      // tempLink.href = blobURL;
      // tempLink.setAttribute('download', decodeURI(value.instance));
      // // 兼容：某些浏览器不支持HTML5的download属性
      // if (typeof tempLink.download === 'undefined') {
      //   tempLink.setAttribute('target', '_blank');
      // }
      // // 挂载a标签
      // document.body.appendChild(tempLink);
      // tempLink.click();
      // document.body.removeChild(tempLink);
      // // 释放blob URL地址
      // window.URL.revokeObjectURL(blobURL);
      const img = await saveToSource(uuid, {
        instanceName: value.instance,
        file,
        altText: value.alt,
        description: value.des,
      });
      if (onOk) onOk(img, index);
      if (onCancel) onCancel();
    } catch (e) {
    } finally {
      setCopyLoading(false);
    }
  };

  const generateFile = () => {
    const instance = ref.current.getInstance();
    const dataUrl = instance.toDataURL({});

    const blob = dataURItoBlob(dataUrl);
    //convertRes2Blob(blob);
    return blob;
  };

  return (
    <Modal
      width={1080}
      visible={visible}
      title={getI18n('general.upload.EditModal.edit_image')}
      footer={null}
      className={css.modal}
      onCancel={onCancel}>
      <div className={css.container}>
        {/* <img src={_src} />
        <button
          onClick={() => {
            const instance = ref.current.getInstance();
            const dataUrl = instance.toDataURL({
              format: 'jpeg',
              quality: 0.75,
            });
            _setSrc(dataUrl);
          }}>
          aaa
        </button> */}
        <div className={css.leftContainer}>
          <div className={css.leftTopContainer}>
            <ImageEditor
              ref={ref}
              cssMaxHeight={470}
              cssMaxWidth={672}
              selectionStyle={{
                cornerSize: 20,
                rotatingPointOffset: 70,
              }}
              usageStatistics={false}
            />
          </div>
          <div className={css.leftBottomContainer}>
            <div className={css.line1}>
              <Button
                onClick={crop}
                className={css.greenBtn}
                ghost
                type='primary'
                icon={<Icon type='iconcrop' />}>
                {getI18n('general.upload.EditModal.crop')}
              </Button>
              <Button
                onClick={rotateLeft}
                className={css.greenBtn}
                ghost
                type='primary'
                icon={<Icon type='iconrotate-l' />}>
                {getI18n('general.upload.EditModal.rotate_left')}
              </Button>
              <Button
                onClick={rotateRight}
                className={css.greenBtn}
                ghost
                type='primary'
                icon={<Icon type='iconrotate-r' />}>
                {getI18n('general.upload.EditModal.rotate_right')}
              </Button>
              <Button
                onClick={flipVertical}
                className={css.greenBtn}
                ghost
                type='primary'
                icon={<Icon type='iconflip-c' />}>
                {getI18n('general.upload.EditModal.flip_vertical')}
              </Button>
              <Button
                onClick={flipHorizontal}
                className={css.greenBtn}
                ghost
                type='primary'
                icon={<Icon type='iconflip-h' />}>
                {getI18n('general.upload.EditModal.flip_horizontal')}
              </Button>
            </div>
            <div className={css.line2}>
              <Button
                ghost
                type='primary'
                className={css.greenBtn}
                onClick={addText}
                icon={<Icon type='icontext' />}>
                {getI18n('general.upload.EditModal.add_text')}
              </Button>
              <Button
                disabled={stack <= 0}
                onClick={undo}
                icon={<Icon type='iconundo' />}>
                {getI18n('general.upload.EditModal.undo')}
              </Button>
              <Button
                disabled={stack <= 0}
                onClick={redo}
                icon={<Icon type='iconredo' />}>
                {getI18n('general.upload.EditModal.redo')}
              </Button>
            </div>
          </div>
        </div>
        <div className={css.rightContainer}>
          <div className={css.title}>{originalName}</div>

          <div className={css.generalText}>
            {replaceI18nVariables(
              getI18n('general.upload.EditModal.uploaded'),
              createdDate,
            )}
          </div>
          <div className={css.generalText}>
            {replaceI18nVariables(
              getI18n('general.upload.EditModal.size'),
              `${size ? Math.floor(size / 1024) : '0'}KB`,
            )}
          </div>
          <div className={css.generalText}>
            {replaceI18nVariables(
              getI18n('general.upload.EditModal.dimension'),
              imageProps.width,
              imageProps.height,
            )}
          </div>
          <div className={css.inputs}>
            <ItemWrapper
              title={getI18n('general.upload.EditModal.instance_name')}
              rightPart={
                <CountWords
                  count={(value.instance || '').length}
                  allCount={100}
                />
              }>
              <BlurValidateInput
                maxLength={100}
                value={value.instance}
                onChange={(e) => {
                  onChange('instance', e);
                }}
                size='large'
              />
            </ItemWrapper>
            <ItemWrapper
              title={getI18n('general.upload.EditModal.alt_text')}
              rightPart={
                <CountWords count={(value.alt || '').length} allCount={100} />
              }>
              <BlurValidateInput
                value={value.alt}
                onChange={(e) => {
                  onChange('alt', e);
                }}
                size='large'
                maxLength={100}
              />
            </ItemWrapper>
            <ItemWrapper
              title={getI18n('general.upload.EditModal.description')}
              rightPart={
                <CountWords count={(value.des || '').length} allCount={500} />
              }>
              <BlurValidateTextArea
                value={value.des}
                onChange={(e) => {
                  onChange('des', e);
                }}
                maxLength={500}
              />
            </ItemWrapper>
          </div>
        </div>
      </div>
      <div className={css.footer}>
        {!showCrop && (
          <>
            <div className={css.footerLeft}>
              <WarningPopReminder
                title={getI18n('general.upload.EditModal.reset_image')}
                content={getI18n(
                  'general.upload.EditModal.reset_image_content',
                )}
                onOkText={getI18n('general.upload.EditModal.reset_image')}
                onOk={handleResetAll}>
                <Button type='primary' disabled={stack <= 0}>
                  {getI18n('general.upload.EditModal.reset_image')}
                </Button>
              </WarningPopReminder>
            </div>
            <div className={css.footerRight}>
              <Button onClick={onCancel}>{getI18n('general.cancel')}</Button>
              <Button
                type='primary'
                onClick={handleSaveToSource}
                loading={copyLoading}
                disabled={
                  saveLoading || (stack <= 0 && _.isEqual(value, valueCopy))
                }>
                {getI18n('general.upload.EditModal.save_as_copy')}
              </Button>
              {/* <Button
                type='primary'
                onClick={handleOnOk}
                loading={saveLoading}
                disabled={
                  copyLoading || (stack <= 0 && _.isEqual(value, valueCopy))
                }>
                Save
              </Button> */}
            </div>
          </>
        )}
      </div>
      <CropModal
        onOk={handleCrop}
        originalName={originalName}
        ratio={ratio}
        src={src}
        visible={showCrop}
        onCancel={() => setShowCrop(false)}
      />
    </Modal>
  );
};
export default EditModal;
